export default __webpack_public_path__ + "static/media/ISCO CLASS-6_SYLLABUS_2025-26.e38850a0.pdf";